export const LOAD_ORGANIZATION = "LOAD_ORGANIZATION";
export const LOAD_ORGANIZATION_SUCCESS = "LOAD_ORGANIZATION_SUCCESS";
export const LOAD_ORGANIZATION_FAILURE = "LOAD_ORGANIZATION_FAILURE";
export const UPDATE_ORGANIZATION = "UPDATE_ORGANIZATION";
export const UPDATE_ORGANIZATION_SUCCESS = "UPDATE_ORGANIZATION_SUCCESS";
export const UPDATE_ORGANIZATION_FAILURE = "UPDATE_ORGANIZATION_FAILURE";
